export { filterReducer } from './reducer'
export { Filter } from './container'

// Export as default for lazy loading
export { Filter as default } from './container'
